import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as awardPis from '../../award-pis'

export const RESOURCE = {
  payload: {
    description:
      'The association(s) between principal investigator (PI) and award. A PI may oversee multiple awards or share an award with other PIs.',
    dimension: awardPis.RESOURCE.payload,
    level: 0,
    name: 'Award PI',
    partialId: PartialId.Standard.create('entry'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
